import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import Loading from '@components/Loading';
import Chart from '@components/charts/Chart';
import {
  apiGetCustomerStatisticsByDeviceInstallation,
  apiGetDeviceStatisticsByStatus
} from '@services/ManageDevices/DeviceServices';
import { showError } from '@components/notification';
import { formatCurrency } from '@utils/utils';
import CustomerIcon from '@assets/images/customer_icon.png';
import DeviceIcon from '@assets/images/device_icon.png';

const CustomerDeviceCharts = () => {
  const [loading, setLoading] = useState(false);
  const [customerData, setCustomerData] = useState(null);
  const [deviceStatusData, setDeviceStatusData] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [customerRes, deviceRes] = await Promise.all([
        apiGetCustomerStatisticsByDeviceInstallation(),
        apiGetDeviceStatisticsByStatus()
      ]);

      setCustomerData(customerRes.data?.data);
      setDeviceStatusData(deviceRes.data?.data);
    } catch (error) {
      console.error('Error fetching customer/device statistics:', error);
      showError('Không thể tải thống kê khách hàng/thiết bị');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return (
      <div
        className="loading-container"
        style={{
          height: '250px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <Loading />
      </div>
    );
  }

  return (
    <div>
      <Row gutter={[16, 16]}>
        {/* Customer Installation Status Donut Chart */}
        <Col md={12} xs={24}>
          <div style={{ textAlign: 'center', width: '100%' }}>
            {/* <h4 style={{ marginBottom: 16, fontWeight: 'bold' }}>Thống kê khách hàng</h4> */}
            <div style={{ position: 'relative' }}>
              <Chart
                options={{
                  colors: ['#52c41a', '#ff4d4f'],
                  labels: [
                    `Đã lắp đặt: ${customerData?.with_device || 0}`,
                    `Chưa lắp đặt: ${customerData?.without_device || 0}`
                  ],
                  legend: {
                    position: 'bottom'
                  },
                  tooltip: {
                    y: {
                      formatter: (val) => `${formatCurrency(val, 0)} khách hàng`
                    }
                  }
                }}
                series={[
                  Number(customerData?.with_device || 0),
                  Number(customerData?.without_device || 0)
                ]}
                height={180}
                type="donut"
              />
              <div
                style={{
                  position: 'absolute',
                  top: '42%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)'
                }}>
                <img
                  src={CustomerIcon}
                  alt="Customer"
                  style={{
                    width: '50px',
                    height: '50px'
                  }}
                />
              </div>
            </div>
          </div>
        </Col>

        {/* Device Status Donut Chart */}
        <Col md={12} xs={24}>
          <div style={{ textAlign: 'center', width: '100%' }}>
            {/* <h4 style={{ marginBottom: 16, fontWeight: 'bold' }}>Trạng thái thiết bị</h4> */}
            <div style={{ position: 'relative' }}>
              <Chart
                options={{
                  colors: ['#1890ff', '#52c41a', '#faad14'],
                  labels: [
                    `Đang sử dụng: ${deviceStatusData?.in_use || 0}`,
                    `Lưu kho: ${deviceStatusData?.stored || 0}`,
                    `Bảo hành: ${deviceStatusData?.under_warranty || 0}`
                  ],
                  legend: {
                    position: 'bottom'
                  },
                  tooltip: {
                    y: {
                      formatter: (val) => `${formatCurrency(val, 0)} thiết bị`
                    }
                  }
                }}
                series={[
                  Number(deviceStatusData?.in_use || 0),
                  Number(deviceStatusData?.stored || 0),
                  Number(deviceStatusData?.under_warranty || 0)
                ]}
                height={180}
                type="donut"
              />
              <div
                style={{
                  position: 'absolute',
                  top: '42%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)'
                }}>
                <img
                  src={DeviceIcon}
                  alt="Device"
                  style={{
                    width: '55px',
                    height: '55px'
                  }}
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CustomerDeviceCharts;
